import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { useListingClinicsByTreatmentQuery } from '../../../generated/queries';
import { getDomain, getDomainBaseUrl, isDomain } from '../../commons/domains';
import { isDefined } from '../../commons/is-defined';

export function mapClinicsByTreatment(
  input: ParagraphListingClinicsByTreatmentFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'LinkList'> {
  return {
    key: 'LinkList',
    input: function useListingClinicsByTreatment() {
      const { data, isLoading, isFetching } = useListingClinicsByTreatmentQuery(
        {
          argument: input.argument || '',
          offset: 0,
          limit: 99999,
        },
      );
      const items =
        data?.listingLocationByTreatmentOffer.items.filter(isDefined);
      if (items) {
        const order =
          getDomain() === 'luks_ch'
            ? ['Luzern', 'Sursee', 'Wolhusen', 'Stans']
            : ['Stans', 'Luzern', 'Sursee', 'Wolhusen'];
        items.sort((a, b) => {
          // Find the indexes (if set).
          let indexA = order.indexOf(a.area?.title || '');
          let indexB = order.indexOf(b.area?.title || '');

          // If not found default to a much higher number
          // - pushing them down to the bottom
          if (indexA < 0) {
            indexA = 999;
          }
          if (indexB < 0) {
            indexB = 999;
          }

          // Calculate the diff.
          const diff = indexA - indexB;
          // If diff = 0 (they are the same) then compare teh title instead.
          if (diff === 0) {
            return a.title.localeCompare(b.title);
          }
          return diff;
        });
      }
      return [
        {
          title: input.title,
          items: items?.map((item) => ({
            Link: buildLink({
              href:
                // Prefix with the domain base URL if needed.
                (!item.domains.includes(getDomain()) &&
                isDomain(item.domains[0])
                  ? getDomainBaseUrl(item.domains[0])
                  : '') + item.path,
            }),
            title: item.title,
            location: item.area?.title || '',
          })),
          htmlId: 'section-contact-information',
        },
        isLoading || isFetching
          ? 102
          : data
          ? data.listingLocationByTreatmentOffer.items.length > 0
            ? 200
            : 404
          : 0,
      ];
    },
  };
}
